export const GET_SHOW_REQUEST = 'GET_SHOW_REQUEST';
export const GET_SHOW_SUCCESS = 'GET_SHOW_SUCCESS';
export const GET_SHOW_FAILURE = 'GET_SHOW_FAILURE';
export const CLEAR_SHOW = 'CLEAR_SHOW';

export const getShowRequest = (data) => ({
    type: GET_SHOW_REQUEST,
    payload: data,
});

export const getShowSuccess = (data) => ({
    type: GET_SHOW_SUCCESS,
    payload: data,
});

export const getShowFailure = (error) => ({
    type: GET_SHOW_FAILURE,
    payload: error,
});

export const clearShow = (data) => ({
    type: CLEAR_SHOW,
    payload: data,
});
